var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmojiAddonWinterHat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF95A8"
    },
    points: "185.379,70.621 195.796,86.756 194.831,105.938 211.937,114.68 220.679,131.787  239.863,130.825 256,141.241 272.136,130.825 291.317,131.789 300.06,114.684 317.166,105.942 316.204,86.758 326.621,70.621  316.204,54.485 317.169,35.304 300.063,26.561 291.321,9.454 272.137,10.417 256,0 239.864,10.417 220.683,9.452 211.94,26.558  194.834,35.299 195.796,54.484 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF8294"
    },
    d: "M278.722,107.581l4.815-9.421l10.691-5.464l-0.601-11.989l6.51-10.086l-6.51-10.086l0.602-11.988 l-10.69-5.464l-5.464-10.691l-11.99,0.601L256,26.483l-10.084,6.51l-11.989-0.602l-5.464,10.69l-10.691,5.463l0.601,11.991 l-6.51,10.086l6.51,10.084l-0.602,11.989l10.69,5.464l4.815,9.423c-8.361,1.185-16.599,2.969-24.676,5.394l3.337,1.706l8.742,17.106 l19.185-0.962L256,141.241l16.136-10.417l19.181,0.964l8.743-17.105l3.342-1.708C295.324,110.551,287.084,108.766,278.722,107.581z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00C3FF"
    },
    d: "M256,123.586c-117.009,0-211.862,138.328-211.862,308.966h423.724 C467.862,261.914,373.009,123.586,256,123.586z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96DCFF"
    },
    d: "M437.526,273.194c-1.578,0.231-3.156,0.461-5.023,0.461c-22.093,0-22.093-17.655-44.186-17.655 c-22.078,0-22.078,17.655-44.157,17.655c-22.059,0-22.059-17.655-44.118-17.655c-22.071,0-22.071,17.655-44.142,17.655 c-22.066,0-22.066-17.655-44.13-17.655s-22.065,17.655-44.13,17.655c-22.065,0-22.065-17.655-44.13-17.655 c-22.055,0-22.055,17.655-44.11,17.655c-1.8,0-3.443-0.126-4.972-0.342c-9.679,23.424-17.244,48.894-22.413,75.83 c7.924,5.226,12.935,12.788,27.386,12.788c22.056,0,22.056-17.655,44.11-17.655c22.066,0,22.066,17.655,44.13,17.655 c22.066,0,22.066-17.655,44.13-17.655c22.066,0,22.066,17.655,44.13,17.655c22.071,0,22.071-17.655,44.142-17.655 c22.059,0,22.059,17.655,44.118,17.655c22.078,0,22.078-17.655,44.157-17.655c22.093,0,22.093,17.655,44.186,17.655 c14.515,0,19.5-7.615,27.473-12.843C454.798,322.129,447.222,296.634,437.526,273.194z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00AAF0"
    },
    d: "M44.138,432.552h423.724c0-8.929-0.319-17.746-0.828-26.483H44.966 C44.457,414.806,44.138,423.623,44.138,432.552z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF95A8"
    },
    d: "M467.862,512H44.138c-4.875,0-8.828-3.953-8.828-8.828v-70.621c0-4.875,3.953-8.828,8.828-8.828 h423.724c4.875,0,8.828,3.953,8.828,8.828v70.621C476.69,508.047,472.737,512,467.862,512z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96DCFF"
    },
    d: "M256.086,247.172c-4.879,0-8.871-3.948-8.871-8.828c0-4.879,3.905-8.828,8.785-8.828h0.086 c4.879,0,8.828,3.948,8.828,8.828C264.914,243.224,260.966,247.172,256.086,247.172z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96DCFF"
    },
    d: "M211.948,388.414c-4.879,0-8.871-3.948-8.871-8.828c0-4.879,3.905-8.828,8.785-8.828h0.086 c4.879,0,8.828,3.948,8.828,8.828C220.776,384.466,216.828,388.414,211.948,388.414z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96DCFF"
    },
    d: "M300.224,388.414c-4.879,0-8.871-3.948-8.871-8.828c0-4.879,3.905-8.828,8.785-8.828h0.086 c4.879,0,8.828,3.948,8.828,8.828C309.052,384.466,305.103,388.414,300.224,388.414z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96DCFF"
    },
    d: "M388.414,388.414c-4.879,0-8.871-3.948-8.871-8.828c0-4.879,3.905-8.828,8.785-8.828h0.086 c4.879,0,8.828,3.948,8.828,8.828C397.241,384.466,393.293,388.414,388.414,388.414z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96DCFF"
    },
    d: "M123.672,388.414c-4.879,0-8.871-3.948-8.871-8.828c0-4.879,3.905-8.828,8.785-8.828h0.086 c4.879,0,8.828,3.948,8.828,8.828C132.5,384.466,128.552,388.414,123.672,388.414z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96DCFF"
    },
    d: "M344.362,247.172c-4.879,0-8.871-3.948-8.871-8.828c0-4.879,3.905-8.828,8.785-8.828h0.086 c4.879,0,8.828,3.948,8.828,8.828C353.19,243.224,349.241,247.172,344.362,247.172z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96DCFF"
    },
    d: "M167.724,247.172c-4.879,0-8.871-3.948-8.871-8.828c0-4.879,3.905-8.828,8.785-8.828h0.086 c4.879,0,8.828,3.948,8.828,8.828C176.552,243.224,172.604,247.172,167.724,247.172z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF6E82"
    },
    d: "M150.069,503.172L150.069,503.172c-4.875,0-8.828-3.953-8.828-8.828v-70.621h17.655v70.621 C158.897,499.22,154.944,503.172,150.069,503.172z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF6E82"
    },
    d: "M185.379,503.172L185.379,503.172c-4.875,0-8.828-3.953-8.828-8.828v-70.621h17.655v70.621 C194.207,499.22,190.254,503.172,185.379,503.172z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF6E82"
    },
    d: "M79.448,503.172L79.448,503.172c-4.875,0-8.828-3.953-8.828-8.828v-70.621h17.655v70.621 C88.276,499.22,84.323,503.172,79.448,503.172z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF6E82"
    },
    d: "M44.138,503.172L44.138,503.172c-4.875,0-8.828-3.953-8.828-8.828v-61.793 c0-4.875,3.953-8.828,8.828-8.828h8.828v70.621C52.966,499.22,49.013,503.172,44.138,503.172z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF6E82"
    },
    d: "M467.862,503.172L467.862,503.172c4.875,0,8.828-3.953,8.828-8.828v-61.793 c0-4.875-3.953-8.828-8.828-8.828h-8.828v70.621C459.034,499.22,462.987,503.172,467.862,503.172z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF6E82"
    },
    d: "M114.759,503.172L114.759,503.172c-4.875,0-8.828-3.953-8.828-8.828v-70.621h17.655v70.621 C123.586,499.22,119.634,503.172,114.759,503.172z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF6E82"
    },
    d: "M291.31,503.172L291.31,503.172c-4.875,0-8.828-3.953-8.828-8.828v-70.621h17.655v70.621 C300.138,499.22,296.185,503.172,291.31,503.172z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF6E82"
    },
    d: "M326.621,503.172L326.621,503.172c-4.875,0-8.828-3.953-8.828-8.828v-70.621h17.655v70.621 C335.448,499.22,331.496,503.172,326.621,503.172z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF6E82"
    },
    d: "M220.69,503.172L220.69,503.172c-4.875,0-8.828-3.953-8.828-8.828v-70.621h17.655v70.621 C229.517,499.22,225.565,503.172,220.69,503.172z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF6E82"
    },
    d: "M256,503.172L256,503.172c-4.875,0-8.828-3.953-8.828-8.828v-70.621h17.655v70.621 C264.828,499.22,260.875,503.172,256,503.172z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF6E82"
    },
    d: "M397.241,503.172L397.241,503.172c-4.875,0-8.828-3.953-8.828-8.828v-70.621h17.655v70.621 C406.069,499.22,402.116,503.172,397.241,503.172z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF6E82"
    },
    d: "M432.552,503.172L432.552,503.172c-4.875,0-8.828-3.953-8.828-8.828v-70.621h17.655v70.621 C441.379,499.22,437.427,503.172,432.552,503.172z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF6E82"
    },
    d: "M361.931,503.172L361.931,503.172c-4.875,0-8.828-3.953-8.828-8.828v-70.621h17.655v70.621 C370.759,499.22,366.806,503.172,361.931,503.172z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M73,282.035c1.956,0.294,4.077,0.448,6.397,0.448c14.13,0,21.587-5.965,27.577-10.767 c5.181-4.147,8.604-6.888,16.534-6.888c7.939,0,11.362,2.741,16.552,6.897c5.992,4.793,13.449,10.759,27.577,10.759 c14.129,0,21.594-5.965,27.586-10.767c5.181-4.147,8.612-6.888,16.543-6.888c7.939,0,11.362,2.741,16.552,6.897 c5.992,4.793,13.449,10.759,27.577,10.759c14.138,0,21.594-5.965,27.595-10.759c5.19-4.156,8.612-6.897,16.552-6.897 c7.932,0,11.362,2.741,16.543,6.888c5.992,4.802,13.449,10.767,27.577,10.767c14.138,0,21.595-5.965,27.595-10.759 c5.19-4.156,8.621-6.897,16.561-6.897c7.957,0,11.577,2.897,16.586,6.897c5.992,4.793,13.457,10.759,27.595,10.759 c2.888,0,5.551-0.242,8.12-0.733l0.263-0.04c-2.226-5.789-4.58-11.452-7.049-17.002c-0.463,0.022-0.844,0.119-1.334,0.119 c-7.948,0-11.569-2.888-16.577-6.897c-5.992-4.793-13.457-10.759-27.604-10.759c-14.138,0-21.594,5.965-27.595,10.759 c-5.19,4.156-8.621,6.897-16.561,6.897c-7.932,0-11.362-2.741-16.543-6.888c-5.992-4.802-13.449-10.767-27.577-10.767 s-21.587,5.965-27.586,10.759c-5.19,4.156-8.621,6.897-16.561,6.897c-7.932,0-11.362-2.741-16.543-6.888 c-5.992-4.802-13.457-10.767-27.586-10.767c-14.13,0-21.587,5.965-27.577,10.759c-5.19,4.156-8.612,6.897-16.552,6.897 c-7.932,0-11.362-2.741-16.543-6.888c-5.992-4.802-13.457-10.767-27.586-10.767c-14.121,0-21.578,5.965-27.569,10.759 c-5.181,4.156-8.612,6.897-16.543,6.897c-0.451,0-0.854-0.021-1.267-0.038c-2.449,5.511-4.787,11.132-6.996,16.876L73,282.035z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M458.233,340.228l-1.355,0.538c-0.534,0.207-1.052,0.474-1.535,0.793 c-2.225,1.44-4.242,3.034-6.259,4.647c-5.009,4-8.629,6.897-16.586,6.897c-7.948,0-11.569-2.888-16.577-6.897 c-5.992-4.793-13.457-10.759-27.604-10.759c-14.138,0-21.594,5.965-27.595,10.759c-5.19,4.156-8.621,6.897-16.561,6.897 c-7.932,0-11.362-2.741-16.543-6.888c-5.992-4.802-13.449-10.767-27.577-10.767s-21.587,5.965-27.586,10.759 c-5.19,4.156-8.621,6.897-16.561,6.897c-7.932,0-11.362-2.741-16.543-6.888c-5.992-4.802-13.457-10.767-27.586-10.767 c-14.13,0-21.587,5.965-27.577,10.759c-5.19,4.156-8.612,6.897-16.552,6.897c-7.932,0-11.362-2.741-16.543-6.888 c-5.992-4.802-13.457-10.767-27.586-10.767c-14.121,0-21.578,5.965-27.569,10.759c-5.181,4.156-8.612,6.897-16.543,6.897 c-7.923,0-11.345-2.741-16.526-6.888c-2.327-1.87-4.672-3.724-7.982-5.698l-1.066-0.529c-1.332,6.191-2.5,12.486-3.566,18.839 c0.51,0.403,1.075,0.758,1.581,1.164c5.982,4.792,13.43,10.766,27.56,10.766s21.587-5.965,27.577-10.767 c5.181-4.147,8.604-6.888,16.534-6.888c7.939,0,11.362,2.741,16.552,6.897c5.992,4.793,13.449,10.759,27.577,10.759 c14.129,0,21.594-5.965,27.586-10.767c5.181-4.147,8.612-6.888,16.543-6.888c7.939,0,11.362,2.741,16.552,6.897 c5.992,4.793,13.449,10.759,27.577,10.759c14.138,0,21.594-5.965,27.595-10.759c5.19-4.156,8.612-6.897,16.552-6.897 c7.932,0,11.362,2.741,16.543,6.888c5.992,4.802,13.449,10.767,27.577,10.767c14.138,0,21.595-5.965,27.595-10.759 c5.19-4.156,8.621-6.897,16.561-6.897c7.957,0,11.577,2.897,16.586,6.897c5.992,4.793,13.457,10.759,27.595,10.759 c14.138,0,21.612-5.965,27.612-10.759c0.529-0.424,1.089-0.82,1.622-1.239C460.684,352.513,459.54,346.321,458.233,340.228z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmojiAddonWinterHat);
export default __webpack_public_path__ + "static/media/emoji-addon-winter-hat.93aa81ee53566aa43bb8ebfffa5d9f28.svg";
export { ForwardRef as ReactComponent };